export default __webpack_public_path__ + "static/docker-extension-meshery-b287e99de36de594e654caa795b5920f.webp";